import { Button, Stack, Text } from 'native-base';

import { SingleLocationForm } from '~/components/SingleLocationsForm';

import { SingleLocationProps } from './types';
import { useSingleLocationController } from './useSingleLocationController';

export const SingleLocation = ({
  isEditing,
  ...props
}: SingleLocationProps) => {
  const {
    control,
    addDateForm,
    appendDate,
    removeDateForm,
    datesFields,
    isDisabledPublishButton,
    isTeamEvent,
    errors,
    handleSubmitForm,
    handleBack,
    isLoading,
    setValue,
  } = useSingleLocationController(props);

  return (
    <Stack>
      <SingleLocationForm
        control={control as any}
        datesFields={datesFields as any}
        appendDate={appendDate as any}
        addDateForm={addDateForm}
        removeDateForm={removeDateForm}
        isTeamEvent={isTeamEvent}
        isEventActivity
        isEditing={isEditing}
        errors={errors}
        setValue={setValue}
      />

      <Stack
        my={4}
        w="100%"
        flexDirection="row"
        justifyContent="space-between"
        alignItems="center"
        space={3}
      >
        <Stack flex={1} ml={4}>
          <Button onPress={handleBack} flex={1} variant="ghost">
            <Text color="primary.600">Back</Text>
          </Button>
        </Stack>
        <Stack flex={1} ml={4}>
          <Button
            onPress={handleSubmitForm}
            flex={1}
            isDisabled={isDisabledPublishButton}
            isLoading={isLoading}
          >
            <Text color="white">Publish</Text>
          </Button>
        </Stack>
      </Stack>
    </Stack>
  );
};
